import React, { FC } from "react";
import { PieChart as RechartsPieChart, Pie, Cell } from "recharts";

import styles from "./PieChart.module.scss";

type Props = {
  size?: number;
  count: number;
  length: number;
};

const PieChart: FC<Props> = ({ size = 60, count, length }) => {
  const gradientUuid = `gradientColor-${crypto.randomUUID()}`;

  const rateData = [
    {
      name: "allocated",
      value: count,
      colorCode: `url(#${gradientUuid})`,
    },
    {
      name: "unallocated",
      value: length - count,
      colorCode: "#E4E4E4",
    },
  ];

  return (
    <div className={styles.wrapper}>
      <p className={styles.rate}>
        <span className={styles.count}>{count}</span>
        <span className={styles.line}>/</span>
        <span className={styles.length}>{length}</span>
      </p>
      <RechartsPieChart width={size} height={size}>
        <defs>
          <linearGradient id={gradientUuid} x1="1" y1="0" x2="0" y2="0">
            <stop offset="0%" stopColor="#51E2FF" />
            <stop offset="100%" stopColor="#2A6DFF" />
          </linearGradient>
        </defs>
        <Pie
          data={rateData}
          dataKey="value"
          innerRadius={size / 2 - 2}
          outerRadius={size / 2}
          startAngle={90}
          endAngle={-270}
          strokeWidth={0}
          animationDuration={300}
          animationEasing={"ease-out"}
        >
          {rateData.map(rate => (
            <Cell key={rate.name} fill={rate.colorCode} />
          ))}
        </Pie>
      </RechartsPieChart>
    </div>
  );
};

export default PieChart;
